import React, { useState, useRef } from 'react';
import messages from '../../utils/messages';

const FileUpload = ({ selectedFiles, onFileSelect, selectedContainerFiles = [] }) => {
  const MAX_FILE_SIZE = 5 * 1024 * 1024;
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  const allowedTypes = [
    'application/pdf',
    'image/jpg',
    'image/jpeg',
    'image/png',
    'application/zip',
    'application/x-zip-compressed',
    'image/gif',
    'image/bmp',
    'image/tiff',
    'image/webp',
    'image/heic',
    'image/heif',
    'text/csv', 
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'                     
  ];
  
  
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };
  
  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const isDuplicateFile = (file, existingFiles) => {
    return existingFiles.some(existing => existing.name === file.name);
  };

  const processFiles = (files) => {
    const newFiles = Array.from(files);
  
    const validFiles = newFiles.filter(file => {
      if (file.size > MAX_FILE_SIZE) {
        alert(messages.notifications.FILE_SIZE_EXCEEDED_5MB(file.name));
        return false;
      }
      if (isDuplicateFile(file, selectedFiles)) {
        alert(messages.notifications.FILE_ALREADY_UPLOADED(file.name));
        return false;
      }

      const fileName = file.name.toLowerCase();
      const hasValidExtension = ['pdf', '.png', '.jpg', '.jpeg', '.zip', '.gif', '.bmp', '.tiff', '.csv', '.xlsx', '.webp', '.heic', '.heif'].some(ext => fileName.endsWith(ext));
      if (!(allowedTypes.includes(file.type) || hasValidExtension)) {
        alert(messages.notifications.FILE_NOT_SUPPORTED(file.name));
        return false;
      }
      return true;
    });
  
    const remainingSlots = 20 - selectedFiles.length - selectedContainerFiles.length;
  
    if (remainingSlots <= 0) {
      alert(messages.notifications.MAX_FILES_UPLOADED);
    } else {
      if (validFiles.length > remainingSlots) {
        alert(messages.notifications.EXTRA_FILES_WILL_BE_IGNORED(remainingSlots));
        validFiles.splice(remainingSlots);
      }
      onFileSelect(validFiles);
    }
  
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };
  
  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
  
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      processFiles(e.dataTransfer.files);
    }
  };
  
  const handleFileInput = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      processFiles(e.target.files);
    }
  };  
  
  return (
    <div 
      className={`upload-area ${isDragging ? 'dragging' : ''}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={() => fileInputRef.current.click()}
    >
      <svg className="upload-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
      </svg>
      <p className="upload-text">Click or drop PDF or image files here</p>
      <input 
        type="file" 
        id="file-input"
        ref={fileInputRef}
        className="hidden-input" 
        onChange={handleFileInput} 
        // accept=".pdf,.jpg,.jpeg,.png,.gif,.bmp,.tiff,.webp"
        // accept=".pdf,.jpeg,.png,.zip"
        accept=".pdf, .jpeg, .jpg, .png, .gif, .bmp, .tif, .tiff, .webp, .heic, .heif, .zip, application/zip, application/x-zip-compressed"
        multiple
      />
    </div>
  );
};

export default FileUpload;
